import { Data } from './data';

export class CatProduit extends Data {

    nom: string;
    description: string;
    parent: CatProduit;
    children: CatProduit[];
    text: string;
    value: number;

    constructor() {

        super();
        // this.montant = 0;
    }

    /* get text(): string{

        return this.designation;
    }

    get value(): number{

        return this.id;
    } */



}
